import { render, staticRenderFns } from "./MarkdownDialog.vue?vue&type=template&id=e27c6790&scoped=true&"
import script from "./MarkdownDialog.vue?vue&type=script&lang=js&"
export * from "./MarkdownDialog.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownDialog.vue?vue&type=style&index=0&id=e27c6790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27c6790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
